import { BeaconInline } from "@octopusdeploy/design-system-components";
import React from "react";
type GitReferenceRuleBeaconProps = {
    onClick: () => void;
};
export const GitReferenceRuleBeacon = ({ onClick }: GitReferenceRuleBeaconProps) => {
    return <BeaconInline open={true} size={"small"} ripple={0.75} onClick={onClick}/>;
};
